import { render, staticRenderFns } from "./TaxDetails.vue?vue&type=template&id=544d0c08&"
import script from "./TaxDetails.vue?vue&type=script&lang=js&"
export * from "./TaxDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports